import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from 'react';
import axios from "axios";
import { Spin } from "antd";
import { axiosErrorHandler, isNullOrUndefined } from "../../../../../swzutils";
import HelpLabel from "../../../components/HelpLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import ValOrDash from "../../../components/ValOrDash";
const DeliveriesByVehicleOperatorWidget = (props, exportedRef) => {
    const [loading, setLoading] = useState(false);
    const [deliveriesByOperator, setDeliveriesByOperator] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    const refresh = () => {
        loadWidgetData();
    };
    const loadWidgetData = () => {
        setLoading(true);
        axios.get(`/admin/v1/dashboard/deliveries-by-vehicle-operator/${props.date}`)
            .then(response => {
            setDeliveriesByOperator(response.data);
        })
            .catch(error => {
            setDeliveriesByOperator(null);
            axiosErrorHandler(error);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const renderValues = (data) => {
        let percent = null;
        if (!isNullOrUndefined(data?.customerDeliveries) && !isNullOrUndefined(data?.totalDeliveries)) {
            if (data.totalDeliveries === 0) {
                percent = 0;
            }
            else {
                percent = Math.round((data.customerDeliveries / data.totalDeliveries) * 100);
            }
        }
        return (_jsxs(_Fragment, { children: [_jsx(ValOrDash, { val: percent }), "% \u00A0", _jsxs("span", { className: "small", children: [_jsx(ValOrDash, { val: data?.customerDeliveries }), " / ", _jsx(ValOrDash, { val: data?.totalDeliveries }), "\u00A0 (", _jsx(ValOrDash, { val: data?.customerDeliveriesIncomplete }), " incomplete)"] })] }));
    };
    return (_jsx(Spin, { spinning: loading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-aqua", children: _jsx(FontAwesomeIcon, { icon: faTruck }) }), _jsx("h2", { className: "widget-value", children: renderValues(deliveriesByOperator?.fleetVehicles) }), _jsx("p", { children: _jsx(HelpLabel, { title: "Company vehicle customer deliveries", helpText: _jsxs("p", { children: ["Deliveries performed by Company/Fleet vehicles, deliveries are classed as ", _jsx("strong", { children: "\"Customer\"" }), "deliveries when the delivery has a sales order ref.  Only deliveries assigned to vehicles that can \"perform customer deliveries\" are counted."] }) }) }), _jsx("div", { className: "widget-separator" }), _jsx("h2", { className: "widget-value", children: renderValues(deliveriesByOperator?.marketplaceVehicles) }), _jsx("p", { children: _jsx(HelpLabel, { title: "Marketplace vehicle customer deliveries", helpText: _jsxs("p", { children: ["Deliveries performed by Contractor/Marketplace vehicles, deliveries are classed as ", _jsx("strong", { children: "\"Customer\"" }), "deliveries when the delivery has a sales order ref.  Only deliveries assigned to vehicles that can \"perform customer deliveries\" are counted."] }) }) })] }) }));
};
export default React.forwardRef(DeliveriesByVehicleOperatorWidget);
